<template lang="pug">
//- SEARCH
.search-criteria-wrapper
    input.search-criteria(
        :class='{ isFocus: searchValue !== "" }',
        :placeholder='searchPlaceHolder',
        v-model='searchValue',
        @keyup.enter='handleSearch()',
        @keyup.esc='reset()'
    )
    svg-icon.search-reset(:name='icon.name', :size='icon.size', v-if='searchValue !== ""', @click.native='reset()')
    .search-filter.l-flex-row--rev(v-if='displaySearchFilters')
        | Filter on :
        select.search-targets(v-model="searchFilter", @change='handleSearchFilter($event)')
            option(v-for='filter in searchFilters', :key='filter.value', :value='filter.value') {{ filter.label }}
</template>

<script>
export default {
    props: {
        displaySearchFilters: Boolean,
        searchFilters: { type: Array, default: () => [] },
        launchSearch: { type: Function, default: () => ({}) },
        updateSearchFilter: { type: Function, default: () => ({}) },
        searchPlaceHolder: { type: String, default: 'Search' },
        icon: { type: Object, default: () => ({}) }
    },

    watch: {
        searchValue: {
            handler: function(newValue, oldValue) {
                if (newValue === '' && newValue !== oldValue) {
                    this.handleSearch()
                }
            }
        },
        searchFilter: {
            handler: function(newValue, oldValue) {
                if (this.searchValue !== '' && newValue !== oldValue) {
                    this.handleSearch()
                }
            }
        }
    },

    data() {
        return {
            searchValue: '',
            searchFilter: ''
        }
    },

    methods: {
        async handleSearchFilter(event) {
            this.searchFilter = event.target.value
            await this.$emit('updateSearchFilter', event.target.value)
        },
        async handleSearch() {
            this.$emit('launchSearch', this.searchValue.trim())
        },
        async reset() {
            this.searchValue = ''
        }
    }
}
</script>
